class MultipackWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cards = this.querySelectorAll('.campaign-discount-card');
    this.quantityInput = document.querySelector('product-form[data-multipack="true"] input[name="quantity"]');

    if (!this.cards.length || !this.quantityInput) return;

    // Set initial quantity from default active card
    const activeCard = this.querySelector('.campaign-discount-card.active');
    if (activeCard) {
      this.quantityInput.value = activeCard.dataset.quantity || 1;
    }

    this.cards.forEach(card => {
      card.addEventListener('click', () => {
        // Remove active class from all cards
        this.cards.forEach(c => c.classList.remove('active'));
        // Add active class to the clicked card
        card.classList.add('active');
        // Update the quantity hidden input
        this.quantityInput.value = card.dataset.quantity || 1;
      });
    });
  }
}

customElements.define('multipack-widget', MultipackWidget);